import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "estimatifs-client" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "infos-client" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Adresse")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Numéro :", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Objets des travaux :", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Montant HT (€) :", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Montant TTC (€) :", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = {
  key: 3,
  class: "gestion-estimatif"
}
const _hoisted_20 = {
  key: 4,
  class: "actions"
}
const _hoisted_21 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_number_format = _resolveComponent("number-format")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_duplicate_icon = _resolveComponent("duplicate-icon")!
  const _component_office_material_icon = _resolveComponent("office-material-icon")!
  const _component_delete_icon = _resolveComponent("delete-icon")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_parametres_estimatif_client = _resolveComponent("parametres-estimatif-client")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, { onClick: _ctx.backToClients }, {
      default: _withCtx(() => [
        _createTextVNode(" Retour à la liste des clients ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.clientCardTitle), 1),
    _createVNode(_component_a_row, {
      type: "flex",
      gutter: 24,
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_skeleton, { loading: _ctx.isClientLoading }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(_ctx.client.adresse), 1),
                  _hoisted_6,
                  (_ctx.client.adresseComplement)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.client.adresseComplement), 1),
                        _hoisted_7
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.client.codePostal) + " " + _toDisplayString(_ctx.client.ville), 1),
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(_ctx.contactDisplay), 1),
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(_ctx.client.email), 1)
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 19 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { direction: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.projetIdSelected,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projetIdSelected) = $event)),
                              style: {"width":"400px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projets, (projet) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: projet.projetId,
                                    value: projet.projetId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(projet.libelle), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createProjet()))
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_plus_outlined)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" Créer un projet ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 8,
                      align: "right"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tooltip, { title: "Archiver les projets" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_popconfirm, {
                              title: `Êtes-vous sûr de vouloir archiver les projets du client ?`,
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.archiverEstimatifsClient())),
                              "ok-text": "Oui",
                              "cancel-text": "Annuler"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  class: "btn-warning"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Archiver les projets du client ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  columns: _ctx.estimatisClientColumns,
                  "data-source": _ctx.estimatifsClient,
                  loading: _ctx.isEstimatifsLoading,
                  pagination: false,
                  "row-class-name": (record) => (record.estArchive ? 'disabled-row' : null),
                  bordered: ""
                }, {
                  headerCell: _withCtx(({ column }) => [
                    _createElementVNode("strong", null, _toDisplayString(column.title), 1)
                  ]),
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'dateCreation')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.obtenirDateAffichage(record)), 1))
                      : (column.key === 'description')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", null, [
                              _hoisted_11,
                              _createTextVNode(" " + _toDisplayString(record.numeroVersion), 1)
                            ]),
                            _hoisted_12,
                            _createElementVNode("span", null, [
                              _hoisted_13,
                              _createTextVNode(" " + _toDisplayString(record.projet), 1)
                            ]),
                            _hoisted_14,
                            _createElementVNode("span", null, [
                              _hoisted_15,
                              _createTextVNode(),
                              _createVNode(_component_number_format, {
                                value: record.montantHt
                              }, null, 8, ["value"])
                            ]),
                            _hoisted_16,
                            _createElementVNode("span", null, [
                              _hoisted_17,
                              _createTextVNode(),
                              _createVNode(_component_number_format, {
                                value: record.montantTtc
                              }, null, 8, ["value"])
                            ]),
                            _hoisted_18,
                            (!record.estArchive && record.hasAlerteSansMarge)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  loading: record.exportState.isDownloadingRealConceptAlerteSansMarge,
                                  size: "small",
                                  danger: "",
                                  onClick: ($event: any) => (_ctx.downloadProjetRealConceptAlerteSansMarge(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Alerte quantités sans marge ")
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "onClick"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                    (column.key === 'honoraire')
                      ? (_openBlock(), _createBlock(_component_number_format, {
                          key: 2,
                          value: record.honoraire
                        }, null, 8, ["value"]))
                      : (column.key === 'gestionEstimatif')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_a_tooltip, { title: "Editer l'estimatif du projet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  onClick: ($event: any) => (_ctx.navigateToEstimatif(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_edit_icon)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_tooltip, { title: "Dupliquer l'estimatif du projet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  onClick: ($event: any) => (_ctx.duplicateEstimatifClient(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_duplicate_icon)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_tooltip, { title: "Gérer le projet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  onClick: ($event: any) => (_ctx.showParametrageEstimatif(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_office_material_icon)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_tooltip, { title: "Supprimer le projet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  onClick: ($event: any) => (_ctx.deleteEstimatifClient(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_delete_icon)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : (column.key === 'editionEstimatif')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_a_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    size: "small",
                                    loading: record.exportState.isDownloadingRealConcept,
                                    onClick: ($event: any) => (_ctx.downloadProjetRealConcept(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Réal' Concept ")
                                    ]),
                                    _: 2
                                  }, 1032, ["loading", "onClick"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    size: "small",
                                    loading: record.exportState.isDownloadingClient,
                                    onClick: ($event: any) => (_ctx.downloadProjetClient(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Client ")
                                    ]),
                                    _: 2
                                  }, 1032, ["loading", "onClick"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    size: "small",
                                    loading: record.exportState.isDownloadingClientAvecMetre,
                                    onClick: ($event: any) => (_ctx.downloadProjetClientAvecMetre(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Client (avec métré) ")
                                    ]),
                                    _: 2
                                  }, 1032, ["loading", "onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        size: "small",
                                        loading: record.exportState.isDownloadingArtisan,
                                        onClick: ($event: any) => (_ctx.downloadProjetArtisan(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Artisan ")
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "onClick"]),
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        size: "small",
                                        loading: record.exportState.isDownloadingArtisanSansMetre,
                                        onClick: ($event: any) => (_ctx.downloadProjetArtisanSansMetre(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Artisan (sans métré) ")
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "onClick"]),
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        size: "small",
                                        loading: record.exportState.isDownloadingArtisanAvecMetre,
                                        onClick: ($event: any) => (_ctx.downloadProjetArtisanAvecMetre(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Artisan (avec métré) ")
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading", "row-class-name"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      placement: "right",
      width: "1280",
      visible: _ctx.parametrageEstimatifIsVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parametrageEstimatifIsVisible) = $event)),
      "destroy-on-close": true,
      onOnClose: _ctx.closeParametrageEstimatif
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_21, " Paramétrage de l'estimatif " + _toDisplayString(_ctx.estimatifClient.numero) + "-" + _toDisplayString(_ctx.estimatifClient.version) + " (" + _toDisplayString(_ctx.estimatifClient.projet) + ") du client " + _toDisplayString(_ctx.civiliteDisplay) + " " + _toDisplayString(_ctx.nomSocieteDisplay), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.estimatifClient)
          ? (_openBlock(), _createBlock(_component_parametres_estimatif_client, {
              key: 0,
              "estimatif-client": _ctx.estimatifClient,
              onUpdateEstimatifClient: _ctx.updateEstimatifClient
            }, null, 8, ["estimatif-client", "onUpdateEstimatifClient"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onOnClose"])
  ]))
}